module.exports = __webpack_public_path__ + "static/drying-00bbafe8da4827ce3377b1224aa8731e.svg";